import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePendingUser } from '../contexts/PendingUserContext';
import { CircularProgress, Box } from '@mui/material';
import routing from '../routing';

function PublicRoute() {
  const { user, loading } = useAuth();
  const { termsAccepted } = usePendingUser();

  // show loading while checking auth
  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // if already authenticated AND terms accepted, redirect to home
  if (user && termsAccepted) {
    return <Navigate to={routing.home.path} replace />;
  }

  // otherwise, allow access to public routes (like login)
  return <Outlet />;
}

export default PublicRoute;